import { createAction } from 'redux-act';
import { OAuthUserState } from './types';

export const oAuthLoginInitiated = createAction('oAuthUser/LOGIN_INITIATED');
export const oAuthLoginSuccess = createAction<OAuthUserState>('oAuthUser/LOGIN_SUCCESS');
export const oAuthLogout = createAction('oAuthUser/LOGOUT');
export const oAuthClearAuthentication = createAction('oAuthUser/CLEAR_AUTHENTICATION');
export const oAuthFailure = createAction<Error>('oAuthUser/FAILURE');
